import { render, staticRenderFns } from "./arrowOptionsColor.vue?vue&type=template&id=52ba8286&scoped=true&lang=pug&"
import script from "./arrowOptionsColor.vue?vue&type=script&lang=js&"
export * from "./arrowOptionsColor.vue?vue&type=script&lang=js&"
import style0 from "./arrowOptionsColor.vue?vue&type=style&index=0&id=52ba8286&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba8286",
  null
  
)

export default component.exports